/* DaoCharm row-aware product-card alignment.
   Equalizes the natural height of title, proof and price rows without truncating
   any product names or relying on guessed fixed line counts. */
(() => {
  'use strict';
  const scopes=[
    '.dc-market__product-page',
    '.dc-market__recommend-grid',
    '.dc-market__spotlight-smalls',
    '#ProductGridContainer #product-grid',
    '.related-products ul.product-grid',
    'product-recommendations ul.product-grid'
  ].join(',');
  const getCards=host=>[...host.children].filter(el=>el.matches('.dc-market__product,li.grid__item'));
  const measureNodes=card=>{
    const home=card.matches('.dc-market__product');
    return {
      title:card.querySelector(home?'.dc-market__product-info > h3':'.card__information .card__heading'),
      proof:card.querySelector('.dc-product-proof'),
      // DC_ALIGN_PRICE_BLOCK_V1: home cards wrap price + deal in .dc-market__prices (.dc-market__price-line was renamed).
      priceLine:card.querySelector(home?'.dc-market__prices, .dc-market__price-line':'.dc-card-price-row'),
      promo:null
    };
  };
  let scheduled=false;
  function equalize(){
    scheduled=false;
    const hosts=[...document.querySelectorAll(scopes)];
    const layouts=[];
    for(const host of hosts){
      const cards=getCards(host);
      if(!cards.length)continue;
      const nodes=cards.map(measureNodes);
      for(const obj of nodes){
        for(const node of Object.values(obj)){
          if(node)node.style.removeProperty('min-height');
        }
      }
      layouts.push({cards,nodes});
    }
    // Read every row before writing to avoid layout-order dependence.
    for(const {cards,nodes} of layouts){
      const rows=[];
      cards.forEach((card,index)=>{
        const top=Math.round(card.getBoundingClientRect().top/4)*4;
        let row=rows.find(x=>Math.abs(x.top-top)<=5);
        if(!row){row={top,indexes:[]};rows.push(row)}
        row.indexes.push(index);
      });
      for(const row of rows){
        if(row.indexes.length<2)continue;
        const dimensions={title:0,proof:0,priceLine:0,promo:0};
        for(const i of row.indexes){
          for(const key of Object.keys(dimensions)){
            const node=nodes[i][key];
            if(node)dimensions[key]=Math.max(dimensions[key],node.getBoundingClientRect().height);
          }
        }
        for(const i of row.indexes){
          for(const key of Object.keys(dimensions)){
            const node=nodes[i][key];
            if(node&&dimensions[key]>0){
              node.style.setProperty('min-height',Math.ceil(dimensions[key])+'px','important');
            }
          }
        }
      }
    }
  }
  function requestAlign(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(equalize);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',requestAlign,{once:true});
  else requestAlign();
  if(document.fonts?.ready)document.fonts.ready.then(requestAlign).catch(()=>{});
  window.addEventListener('load',requestAlign,{once:true});
  window.addEventListener('resize',requestAlign,{passive:true});
  document.addEventListener('shopify:section:load',requestAlign);
  window.dcCardAlign=requestAlign;
  const main=document.getElementById('MainContent');
  if(main&&'MutationObserver' in window){
    // DC_ALIGN_ON_PAGE_SWITCH_V1 (20261015): paged product groups are toggled with the `hidden`
    // attribute (no nodes added/removed), so also re-align when visibility changes. Cards in a hidden
    // page measure 0px and could not be aligned until they become visible.
    const observer=new MutationObserver(mutations=>{
      if(mutations.some(m=>m.addedNodes.length||m.removedNodes.length||m.type==='attributes'))requestAlign();
    });
    observer.observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
  }
})();
